import {
  FaUser,
  FaSignOutAlt
} from 'react-icons/fa';
import { Button, Menu } from '@oliasoft-open-source/react-ui-library';

export interface IUserMenuProps {
  userName?: string;
  navToUserProfile: () => void;
  onClickLogOut: () => void;
  mainPath?: string;
  isCompanyMode?: boolean;
}

export const UserMenu = ({
  userName = '',
  navToUserProfile,
  onClickLogOut,
}: IUserMenuProps) => {
  const initials = userName
    .split(' ')
    .filter((v) => v)
    .map((v) => v[0].toUpperCase())
    .join('');

  const name = userName.split(' ').join('').length < 35
    ? userName
    : userName.split(' ').slice(0, 3).join(' ');

  const userMenu = [
    {
      type: 'Heading',
      label: name,
    },
    {
      type: 'Option',
      label: 'Profile',
      icon: <FaUser color="#ff6600" />,
      onClick: navToUserProfile,
    },
    { type: 'Divider' },
    {
      type: 'Option',
      label: 'Sign out',
      icon: <FaSignOutAlt color="#ff6600" />,
      onClick: onClickLogOut,
    },
  ];

  return (
    <Menu
      menu={{
        trigger: 'Component',
        placement: 'bottom-end',
        component: <Button label={initials} colored round />,
        sections: userMenu,
      }}
    />
  );
};
